import { DrawerHeader } from 'syf-component-library/ui/atoms';
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { colors, fontSizes, fontWeights, lineHeights, notificationBar, spacing } from 'syf-component-library/defaultTheme';
import { Body, H5 } from 'syf-component-library/ui/typography';
import { MessageBox } from 'syf-component-library/ui/patterns';
import { Inset } from 'syf-component-library/ui/spacing';
export const CustomDrawerHeader = styled(DrawerHeader) `
  align-items: center;

  & div {
    height: fit-content;
    width: fit-content;
  }

  & > div:nth-child(1) {
    max-height: unset;
    max-width: unset;

    img {
      width: 72px;
      height: 55px;
      max-width: unset;
    }
  }

  & > div:nth-child(2) div p {
    font-weight: ${fontWeights.regular};
  }
`;
export const Divider = styled.div `
  width: 100%;
  height: 2px;
  background-color: ${colors.mercury};
  margin: 0;
`;
export const ErrorMessageContainer = styled(Inset) `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-inline: auto;

  @media ${query.lessThanSmall} {
    width: 90%;
  }
`;
export const ErrorImage = styled.img `
  height: auto;
  width: 100%;
  max-width: 190px;
  margin: auto;

  @media ${query.lessThanSmall} {
    max-height: 96px;
  }
`;
export const ErrorImageInset = styled(Inset) `
  @media ${query.lessThanMedium} {
    padding-bottom: ${spacing.large}px;
  }
`;
export const ErrorTitle = styled(H5) `
  line-height: ${lineHeights.root};

  @media ${query.lessThanMedium} {
    font-size: ${fontSizes.medium}px;
    text-align: center;
  }
`;
export const ErrorDescription = styled(Body) `
  @media ${query.lessThanSmall} {
    text-align: center;
  }
`;
const borderColors = {
    success: notificationBar.success.badgeBackground,
    warning: notificationBar.warning.badgeBackground,
    info: notificationBar.info.badgeBackground,
    error: notificationBar.error.badgeBackground
};
const backgroundColors = {
    success: notificationBar.success.background,
    warning: notificationBar.warning.background,
    info: notificationBar.info.background,
    error: notificationBar.error.background
};
export const MessageBoxSyf = styled(MessageBox) `
  border: 2px solid ${({ type }) => borderColors[type]};
  background-color: ${({ type }) => backgroundColors[type]};
  padding-right: ${spacing.base}px;
  text-align: left;
  div:first-child {
    width: auto;
    margin-right: ${spacing.base}px;
  }
`;
